import { cn } from "@/lib/utils";
import buratti from "@/assets/logos/buratti-logo.svg.asset.json";
import emons from "@/assets/logos/emons.png.asset.json";
import fiege from "@/assets/logos/fiege.png.asset.json";
import gebruederMayer from "@/assets/logos/gebrueder-mayer.png.asset.json";
import hartmann from "@/assets/logos/hartmann.png.asset.json";
import heinzHuber from "@/assets/logos/heinz-huber.png.asset.json";
import hensel from "@/assets/logos/hensel.png.asset.json";
import igsSchreiner from "@/assets/logos/igs-schreiner.png.asset.json";
import offergeld from "@/assets/logos/offergeld.png.asset.json";
import rth from "@/assets/logos/rth.png.asset.json";
import schwenk from "@/assets/logos/schwenk-logistik.png.asset.json";
import vsLogistics from "@/assets/logos/vs-logistics.png.asset.json";
import wero from "@/assets/logos/wero.png.asset.json";
import wolf from "@/assets/logos/wolf-spedition.png.asset.json";

const LOGOS: { name: string; url: string }[] = [
  
  { name: "VS Logistics", url: vsLogistics.url },
  { name: "Schwenk Logistik", url: schwenk.url },
  { name: "Hartmann International", url: hartmann.url },
  { name: "Emons", url: emons.url },
  { name: "Wero", url: wero.url },
  { name: "Offergeld Logistik", url: offergeld.url },
  { name: "IGS Schreiner", url: igsSchreiner.url },
  { name: "Buratti", url: buratti.url },
  { name: "Fiege", url: fiege.url },
  { name: "Gebrüder Mayer", url: gebruederMayer.url },
  { name: "Heinz Huber", url: heinzHuber.url },
  { name: "Hensel", url: hensel.url },
  { name: "RTH", url: rth.url },
  { name: "Wolf Spedition", url: wolf.url },
];

export function LogoCloud({
  title,
  compact = false,
  logoSpacing = "normal",
}: {
  title?: string;
  compact?: boolean;
  logoSpacing?: "normal" | "wide";
}) {
  // duplicate the array for a seamless infinite loop
  const track = [...LOGOS, ...LOGOS];

  return (
    <section
      className={cn(
        "bg-white",
        compact ? "pb-14 pt-8 md:pb-16 md:pt-10" : "pb-16 pt-12 md:pb-20 md:pt-16",
      )}
    >
      <div className="container-wide">
        {title && (
          <p
            className={cn(
              "text-center font-body uppercase tracking-[0.3em] text-muted-foreground",
              compact ? "text-[10px] mb-6" : "text-sm mb-10",
            )}
          >
            {title}
          </p>
        )}
      </div>

      <div className="relative overflow-hidden group">
        {/* Edge fade overlays */}
        <div
          className={cn(
            "pointer-events-none absolute inset-y-0 left-0 z-10 bg-linear-to-r from-white to-transparent",
            compact ? "w-16 md:w-24" : "w-24 md:w-40",
          )}
        />
        <div
          className={cn(
            "pointer-events-none absolute inset-y-0 right-0 z-10 bg-linear-to-l from-white to-transparent",
            compact ? "w-16 md:w-24" : "w-24 md:w-40",
          )}
        />

        <div className="flex w-max items-center animate-logo-scroll group-hover:[animation-play-state:paused]">
          {track.map((logo, i) => (
            <div
              key={`${logo.name}-${i}`}
              className={cn(
                "flex shrink-0 items-center justify-center",
                logoSpacing === "wide"
                  ? compact
                    ? "mx-12 md:mx-16"
                    : "mx-16"
                  : compact
                    ? "mx-8 md:mx-10"
                    : "mx-12",
              )}
            >
              <img
                src={logo.url}
                alt={logo.name}
                className={cn(
                  "w-auto object-contain grayscale opacity-60 transition duration-300 hover:grayscale-0 hover:opacity-100",
                  compact ? "h-6 md:h-7" : "h-10 md:h-12",
                )}
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
